import React from "react";
import { Link, Outlet, useMatch } from "react-router";
import MainNavbar from "../../components/Navbars/MainNavbar";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

function NavigationButton({
  url,
  defaultText,
  sub,
  transKey,
}: {
  url: string;
  defaultText: string;
  sub?: "overige" | "sales";
  transKey?: string;
}) {
  const translationKey = transKey ? transKey : `rapportages.${sub ? "subpages" : "mainpages"}.${url}`;

  return (
    <Tab
      component={Link}
      label={<TranslationWrapper tDefault={defaultText} tKey={translationKey} />}
      to={`./${sub ? sub + "/" : ""}${url}`}
    />
  );
}

const Rapportages = () => {
  const mainPageRoute = useMatch("/manager/rapportages/algemeen");
  const salesRoute = useMatch("/manager/rapportages/sales/:sub");
  const miscRoute = useMatch("/manager/rapportages/overige");

  return (
    <div>
      <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Rapportage"} tKey={"rapportages.pageTitle"} />} />
      <Tabs value={mainPageRoute ? 0 : salesRoute ? 1 : miscRoute ? 2 : 0}>
        <NavigationButton defaultText={"Algemeen"} url={"algemeen"} />
        <NavigationButton defaultText={"Sales"} sub={"sales"} transKey={"mainpages.sales"} url={"producten"} />
        <NavigationButton defaultText={"Producten"} sub={"overige"} url={""} />
      </Tabs>
      {salesRoute ? (
        <Tabs
          value={
            salesRoute.params.sub === "producten"
              ? 0
              : salesRoute.params.sub === "tafels"
                ? 1
                : salesRoute.params.sub === "export"
                  ? 2
                  : 0
          }
        >
          <NavigationButton defaultText={"Producten"} sub={"sales"} url={"producten"} />
          <NavigationButton defaultText={"Tafels"} sub={"sales"} url={"tafels"} />
          <NavigationButton defaultText={"Export"} sub={"sales"} url={"export"} />
        </Tabs>
      ) : null}
      <Outlet />
    </div>
  );
};

export default Rapportages;
